<template>
  <footer style="clear: both" id="footer">
    <v-row justify="space-around" align="start">
      <v-col cols="3" justify="center" align="center">
        <router-link to="/">
          <v-img
            class="pb-5"
            :src="require('@/assets/' + logoAsset)"
            max-height="120"
            max-width="120"
            contain
          />
        </router-link>
        <p class="tiny-font">
          <template v-for="(eula, idx) in eulas">
            <span @click="fetchEULA(eula)" style="cursor: pointer" :key="idx">{{
              eula.title
            }}</span>
            <br :key="'br-' + idx" />
          </template>
        </p>
      </v-col>
      <v-col cols="2">
        <ul class="dots-out tiny-font">
          <li class="title-gray pb-5">
            <b>InstaCares</b>
          </li>
          <li class="pb-5">
            <router-link to="/saibamais">Serviços</router-link>
          </li>
          <li class="pb-5">
            <router-link to="/sobre">Sobre nós</router-link>
          </li>
          <li>
            <router-link to="/faq">Perguntas frequentes</router-link>
          </li>
        </ul>
      </v-col>
      <v-col cols="2">
        <ul class="dots-out tiny-font">
          <li class="title-gray pb-5">
            <b>Faça Parte</b>
          </li>
          <li class="pb-5">
            <router-link to="/login">Login</router-link>
          </li>
          <li>
            <router-link to="/registro/Usuário">Cadastrar</router-link>
          </li>
        </ul>
      </v-col>
      <v-col cols="2">
        <ul class="dots-out tiny-font">
          <li class="title-gray pb-5">
            <v-row align="center">
              <b>Redes Sociais</b>
            </v-row>
          </li>
          <li class="pb-5">
            <v-row align="center">
              <img
                class="icon-size mr-3"
                src="../assets/img/face.svg"
                height="25px"
                width="25px"
              />
              <a href="https://www.facebook.com/InstaCares/" target="_blank">
                <span>Facebook</span>
              </a>
            </v-row>
          </li>
          <li class="pb-5">
            <v-row align="center">
              <img
                class="icon-size mr-3"
                src="../assets/img/insta.svg"
                height="25px"
                width="25px"
              />
              <a href="https://www.instagram.com/insta_cares/" target="_blank">
                <span>Instagram</span>
              </a>
            </v-row>
          </li>
          <li>
            <v-row align="center">
              <img
                class="icon-size mr-3"
                src="../assets/img/youtube.svg"
                height="25px"
                width="25px"
              />
              <a
                href="https://www.youtube.com/channel/UCEff5AfMjocVLOcH2mqPn_g?view_as=subscriber"
                target="_blank"
              >
                <span>Youtube</span>
              </a>
            </v-row>
          </li>
        </ul>
      </v-col>
      <v-col cols="2">
        <ul class="dots-out tiny-font">
          <li class="title-gray pb-5">
            <b>Contato</b>
          </li>
          <li class="pb-5">
            <router-link to="/contato">Enviar Mensagem</router-link>
          </li>
          <li class="pb-5">(11) 99386-3001</li>
          <li class="pb-5">(11) 99284-3570</li>
          <li>contato@instacares.com.br</li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" justify="center" align="center">
        <p class="tiny-font mb-0">
          Copyright &copy; 2020 InstaCares Tecnologia Ltda. - Todos os direitos
          reservados
        </p>
      </v-col>
    </v-row>
  </footer>
</template>

<script>
import axios from 'axios'
//import LocaleSwitcher from "@/components/LocaleSwitcher"

export default {
  components: {},
  name: 'Footer',
  data: () => ({
    slideIndex: 1,
    eulas: [
      {
        title: 'Termos e Condições',
        type: 'termos_condicoes',
        route: '/termos-condicoes',
        fileUrl: null
      },
      {
        title: 'Termos e Condições Profissionais',
        type: 'termos_condicoes_profissional',
        route: '/termos-condicoes-profissional',
        fileUrl: null
      },
      {
        title: 'Política de Privacidade',
        type: 'politica_privacidade',
        route: '/politica-privacidade',
        fileUrl: null
      }
    ]
  }),
  computed: {
    logoAsset() {
      return process.env.VUE_APP_INSTA_LOGO_NB
    }
  },
  methods: {
    newTab(e) {
      if (e.fileUrl && e.fileUrl.length > 0) {
        var win = window.open(e, '_blank')
        win.focus()
      }
    },
    fetchEULA(e) {
      //console.log('fetching EULA pdf from server...');
      let vm = this
      vm.loading = true

      axios
        .get(process.env.VUE_APP_ITS_API + 'get/get-termo_eula.php', {
          params: {
            tipo: e.type
          }
        })
        .then(response => {
          vm.loading = false
          switch (response.data.status) {
            case 201:
            case 200:
              e.fileUrl = response.data.data.file
              var win = window.open(e.fileUrl, '_blank')
              win.focus()
              break
            default:
              console.log(response.data.reason)
              break
          }
        })
    }
  },
  mounted() {
    //this.fetchEULA();
  }
}
</script>
<style scoped>
.v-application a {
  text-decoration: none;
  color: unset;
}

/* footer {
  z-index: 99;
} */
</style>
